export const CATEGORY_OVERVIEW_SCREEN = 'projectCategoryOverviewScreen' as const;
export const TEMPLATE_OVERVIEW_SCREEN = 'projectTemplateOverviewScreen' as const;
export const PROJECT_TYPE_SCREEN = 'projectTypeScreen' as const;
export const IMPORT_SCREEN = 'importScreen';

export const TEMPLATE_BUNDLES_SCREENS = {
	presetBundlesScreen: 'presetBundlesScreen',
	customizeBundlesScreen: 'customizeTemplateBundlesScreen',
	bundleCreationLoadingScreen: 'bundleCreationLoadingScreen',
} as const;

export const AGILITY_SCRUM = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
export const AGILITY_KANBAN = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
export const CLASSIC_KANBAN = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
export const CLASSIC_SCRUM = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
export const PROJECT_SHARED_CONFIG_NAME = 'PROJECT_SHARED_CONFIG_NAME' as const;
export const PROJECT_SHARED_CONFIG_NAME_GALAXIA = 'PROJECT_SHARED_CONFIG_NAME_GALAXIA' as const;
export const PROJECT_SHARED_CONFIG_DESCRIPTION = 'PROJECT_SHARED_CONFIG_DESCRIPTION' as const;
export const PROJECT_SHARED_CONFIG_DESCRIPTION_GALAXIA =
	'PROJECT_SHARED_CONFIG_DESCRIPTION_GALAXIA' as const;

// Analytics events
export const BACK_TO_PROJECT_TYPES = 'backToProjectTypes';
export const BACK_TO_PROJECT_TEMPLATES = 'backToProjectTemplates';
export const CHANGE_TEMPLATE = 'changeTemplate';
export const CHANGE_PROJECT_TYPE = 'changeProjectType';
export const VIEW_TEMPLATE_OVERVIEW = 'viewTemplateOverview';
export const CREATE_PROJECT_SOURCE_NAME = 'createProject';
export const CONSOLIDATED_PROJECT_DETAILS_SOURCE_NAME = 'consolidatedProjectDetails';

export const TEAM_NAME = 'helix';
export const PROJECT_CREATE_APP_NAME = 'project-create';

export const PACKAGE_NAME = 'jiraProjectCreateCommon';

export const CROSS_TEAM_MANAGED_KEY = 'com.pyxis.greenhopper.jira:gh-cross-team-template';

export const CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY =
	'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
